// extracted by mini-css-extract-plugin
export default {"intro":"TimeSpan_intro__SlKie","title":"TimeSpan_title__BbxIq","subtitle":"TimeSpan_subtitle__E7n+f"};